export default __webpack_public_path__ + "954c37f8ef9868316651f52bc35efa34.svg";